import CASL from '@/utils/constants/casl'

export default {
  path: 'company-name',
  children: [
    {
      path: '',
      name: 'company-name.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.COMPANY_NAME
      },
      component: () => import('./list/CompanyNameListPage.vue')
    }
  ]
}
